module.exports = __webpack_public_path__ + "static/WS_appflows_virtual_6-145e5871fad037bd6bef0fe999c96709.gif";